<template>
	<div>
		<v-dialog 
            v-model="secondaryUserDialog"
            transition="dialog-top-transition"
			persistent
            max-width="45%">
            <v-card>
                <v-card-title class="primary darken-2">
                    <div class="white--text">Add an Additional User</div>
                    <v-spacer></v-spacer>
					<v-btn 
						icon
						class="ml-3 white--text"
						@click="closeSecondary()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
                </v-card-title>
                <v-card-text class="pt-2">
                    <SecondaryUser 
                        :parentUserId="parentUserId"
                        :project="secondaryProject"
						:thisUser="thisUser"
						:resetCreateNewUser="resetCreateNewUser"
						@refreshUsers="refreshUsers" />
                </v-card-text>
            </v-card>
        </v-dialog>

		<v-alert
			v-if="projects.length == 0"
			class="my-12 py-2 avenir_book project_title grey--text text--darken-2"
			color="white"
			prominent
			border="left"
			elevation="2">
			<v-icon large class="my-2 mx-4 grey--text">mdi-information</v-icon>There are no {{ project_type }} projects to show at this time.
		</v-alert>

		<v-card
			v-else
			v-for="prj of projects" 
			:key="prj.project_id"
			class="">

			<v-card-title v-if="show_this == '' || show_this == prj.project_id"
				class="py-0" 
				:class="show_this != prj.project_id ? 'mb-4' : ''">

				<div @click="showProject(prj)" class="d-block flex-grow-1 py-3" style="cursor: pointer">
					<div class="d-flex d-block align-center">
						<div class="d-inline d-flex align-center" style="width:50%">
							<customIcon :name="prj.modinfo.module_key" class="d-inline ml-n2 mr-1 lend--text icon-size-header" />
							<div class="d-inline sansation project_title lend--text">
								<div class="d-inline">{{ prj.modinfo.module_name }}</div>
								<div v-if="prj.name != ''" class="d-inline">:: {{ prj.name }}</div>
							</div>

							<div v-if="show_addUserFeedback" class="ml-6 error--text text--darken-3 avenir_medium feedback_smaller">
								{{ added_user_feedback }}
							</div>
						</div>
						
						<div class="d-inline" style="width:10%; margin-top:-45px">
							<div class="click_indicator"></div>
						</div>

						<div v-if="!prj.show" class="d-inline d-flex justify-end sansation project_title" style="width:40%">
							<div class="d-inline mr-3 general_grey--text">Status:</div>
							<div class="d-inline mr-3" :class="prj.status_color">
								{{ prj.status_text }}
							</div>
							<div class="d-inline">
								<v-progress-circular 
									:value="Math.ceil(prj.complete)"
									:class="prj.status_color"
									class="pa-0 ma-0" 
									size="28" 
									width="2">
									<div :style="prj.complete == 100 ? 'font-size: .65rem' : 'font-size: .75rem'"
										:class="prj.status_color+'--text font-weight-bold'">
										{{ prj.complete }}
									</div>
								</v-progress-circular>
							</div>
						</div>

						<div v-if="prj.show" class="d-inline d-flex justify-end" style="width:40%">
							<v-btn
								v-if="prj.user_id == authUser.id"
								small
                                outlined
								elevation=0
                                color="primary lighten-1"
                                class="mt-1 mr-3"
                                :disabled="prj.is_archived"
								@click="addSecondaryUser(prj)">
                                Add User
                            </v-btn>

							<router-link v-if="prj.user_id == authUser.id || (prj.users.length && (prj.users[0].read || prj.users[0].write))"
								push
								:to="prj.overview_route"
								class="button_link">
								<v-btn
									class="mr-3" 
									small
									elevation=0
									color="primary lighten-1">
									View Overview
								</v-btn>
							</router-link>

							<router-link v-if="prj.user_id == authUser.id || (prj.users.length && (prj.users[0].read || prj.users[0].write))"
								push
								:to="prj.questionnaire_route"
								class="button_link">
								<v-btn
									class=""
									small
									elevation=0
									color="primary lighten-1">
									View Questionnaire
								</v-btn>
							</router-link>
						</div>
					</div>
					
					<v-divider v-if="!prj.show" class="py-1"></v-divider>

					<v-progress-linear
						v-else
						:active="true"
						buffer-value=100
						height=6
						striped
						class="d-block my-2"
						:value="prj.complete"
						:color="prj.status_progress_color">
					</v-progress-linear>

					<div class="d-flex d-block sansation project_subtitle justify-space-between align-center">
						<div v-if="!prj.show" class="d-flex d-inline justify-start">
							<div class="d-inline mr-3 general_grey--text">Current Step:</div>
							<div class="d-inline primary--text text--darken-1">{{ prj.stage_name_text }}</div>
						</div>

						<div v-if="!prj.show" class="d-flex d-inline justify-end">
							<div class="general_grey--text d-inline">Est. Completion Date:</div>
							<div class="ml-3 primary--text text--darken-1 d-inline">{{ formatDate(prj.close_date, 'mmmm d, yyyy') }}</div>
						</div>

					</div>
				</div>               
			</v-card-title>

			<v-expand-transition>
				<div v-if="prj.show">
					<v-card-text class="my-0 py-0">
						<v-card v-if="project_detail_view == 'overview'" elevation="0" class="pl-9 pr-0 mb-8">
							<div class="justify-space-between d-flex pt-2 pb-4 align-center">
								<div class="d-inline mr-12">
									<div class="d-block pr-1 sansation project_subtitle general_grey--text">Status</div>
									<v-divider class="pb-2"></v-divider>
									<div class="d-block avenir_book project_subtitle font-weight-bold" :class="prj.status_color">
										{{ prj.status_text }}: <span class="ml-3" :class="prj.status_color">{{ Math.ceil(prj.complete) }}%</span> complete
									</div>
								</div>

								<div class="d-inline mr-12">
									<div class="d-block pr-1 sansation project_subtitle general_grey--text">Current Step</div>
									<v-divider class="pb-2"></v-divider>
									<div class="d-block avenir_book project_subtitle primary--text text--darken-1">{{ prj.stage_name_text }}</div>
								</div>
								
								<div class="d-inline mr-12">
									<div class="d-block pr-1 sansation project_subtitle general_grey--text">Start Date</div>
									<v-divider class="pb-2"></v-divider>
									<div class="d-block avenir_book project_subtitle primary--text text--darken-1">{{ formatDate(prj.date_initialized, 'mmm. d, yyyy') }}</div> 
								</div>
								
								<div class="d-inline text-right">
									<div class="d-block pr-1 sansation project_subtitle general_grey--text">Estimated Completion Date</div>
									<v-divider class="pb-2"></v-divider>
									<div class="d-block avenir_book project_subtitle primary--text text--darken-1">{{ formatDate(prj.close_date, 'mmm. d, yyyy') }}</div>
								</div>

								<!-- <div class="d-inline text-right">
									<div class="d-block pr-1 sansation project_subtitle general_grey--text">Project Progress</div>
									<v-divider class="pb-2"></v-divider>
									<div class="d-block avenir_book project_subtitle primary--text text--darken-1">{{ Math.ceil(prj.complete) }}% Complete</div>
								</div> -->
							</div>
						</v-card>

						<!-- <v-card v-if="project_detail_view == 'activity'" elevation="0" class="px-5 pb-12">
							<ActivityLogs
								:projectDetails="prj"
								:refresh_logs="refresh_logs"
								@pullActivityLogs="pullActivityLogs"
								@logManualNote="logManualNote" /> 
						</v-card> -->

						<!-- <v-card v-if="project_detail_view == 'docs'" elevation="0" class="px-5 pb-12"> -->
						<v-card class="pl-4 pr-0 pb-12" elevation="0">
                            <div v-if="!prj.dlvs.length && !prj.docs.length" class="pa-4 mb-6 sansation project_subtitle">
                                <span class="general_grey--text">Documentation:</span>
								<div class="pa-4 avenir_book project_subtitle ">No documents to show yet.</div>
                            </div>

                            <div v-if="(prj.users.length && prj.users[0].deliverables) && prj.dlvs.length" class="pa-4 mb-6 sansation project_subtitle general_grey--text">
                            <!-- <div v-if="prj.dlvs.length" class="pa-4 mb-6 sansation project_subtitle general_grey--text"> -->
                                <ProjectDeliverables
                                    :projectDeliverables="prj"
                                    :refresh_delivs="refresh_delivs"
                                    @pullProjectDelivs="pullProjectDelivs"
                                    @confirmedDeliverable="confirmedDeliverable" />
                            </div>
                            
                            <div v-if="prj.docs.length" class="pa-4 sansation project_subtitle general_grey--text">
                                <ProjectFiles
                                    :projectDetails="prj"
                                    :refresh_docs="refresh_docs"
                                    @pullProjectDocs="pullProjectDocs" />
                            </div>

							<div v-if="!authUser.is_secondary" class="pa-4 sansation project_subtitle general_grey--text">
                                <div v-if="prj.admins.length" class="mt-3 subtitle-1 d-block">Clients</div>
								<v-data-table
									v-if="prj.admins.length"
									:headers="admin_header"
									:items="prj.admins"
									hide-default-footer
									class="mb-12">
									
									<template v-slot:header="{ headers }">
										<thead>
											<tr>
												<td v-for="column in headers" :key="column.value">
													{{column.text}}
												</td>
											</tr>
										</thead>
									</template>

									<template v-slot:body="{ items }">
										<tbody name="list" is="transition-group">
											<tr v-for="item in items" :key="item.user_id" class="item-row avenir_book">
												<td class="text-start">{{ item.first_name }} {{ item.last_name }}</td>
												<td class="text-start">{{ item.phone }}</td>
												<td class="text-start">{{ item.user_email }}</td>
											</tr>
										</tbody>
									</template>
								</v-data-table>

								<ProjectUsers
									v-if="prj.users.length"
								    :projectUsers="prj"
									:authUser="authUser"
									@refreshUsers="refreshUsers" />
                            </div>
                        </v-card>
					</v-card-text>
				</div>
			</v-expand-transition>
		</v-card>

		<v-card class="py-0 mt-8 mb-10">
			<v-card-title class="pa-4">
                <div class="sansation project_title lend--text">Contact SRG</div>
			</v-card-title>

			<v-card-text>
				<div class="ma-0 px-4">
                	<div class="mb-6 avenir_book project_title">Our support team is here to answer any questions and help keep your project on track.</div> 
					
					<div class="mb-6 d-flex justify-space-between">                         
						<div class="align-self-start">
							<h4 class="my-2 sansation project_subtitle">General Questions</h4>
							<div class="mt-2 avenir_book">Mikaela Devine</div>
							<div class="avenir_book font-weight-light">
								e: <a href="mailto:mikaela.devine@successionresourcegroup.com">mikaela.devine@successionresourcegroup.com</a><br>
								p: (503) 427 9910 ext. 1305
							</div>
							<div class="mt-4 avenir_book">Robin Tippie</div>
							<div class="avenir_book font-weight-light">
								e: <a href="mailto:robin.tippie@successionresourcegroup.com">robin.tippie@successionresourcegroup.com</a><br>
								p: (503) 427 9910 ext. 1308
							</div>
						</div>

						<div class="align-self-start">
							<h4 class="my-2 sansation project_subtitle">Technical Support</h4>
							<div class="mt-2 avenir_book">Cliff Weiler</div>
							<div class="avenir_book font-weight-light">
								e: <a href="mailto:cliff.weiler@successionresourcegroup.com">cliff.weiler@successionresourcegroup.com</a><br>
								p: (503) 427 9910 ext. 1314
							</div>
						</div>

						<div class="align-self-start">
							<h4 class="my-2 sansation project_subtitle">Sales</h4>
							<div class="mt-2 avenir_book">Nicole Sinclair</div>
							<div class="avenir_bookfont-weight-light">
								e: <a href="mailto:nicole.sinclair@successionresourcegroup.com">nicole.sinclair@successionresourcegroup.com</a><br>
								p: (503) 427 9910 ext. 1302
							</div>
						</div>
					</div>
				</div>
            </v-card-text>
        </v-card>
	</div>
</template>

<script>
	import axios from "axios";
import Cookie from "js-cookie";
	import appUrls from '../helpers/environment';
	import dateFormat, { masks } from "dateformat";

	import ProjectFiles from './ProjectFiles';
	import ProjectDeliverables from './ProjectDeliverables';
	import ProjectUsers from './ProjectUsers.vue';
	import SecondaryUser from './SecondaryUser.vue';
	
	export default {
    	name: 'DashProjects',
		
		components: {
            ProjectFiles,
            ProjectDeliverables,
			ProjectUsers,
			SecondaryUser
		},

		props: {
			projects: Array,
			project_type: String,
			authUser: Object
		},

		data () {
			return {
				show_this: '',
				project_detail_view: 'overview',
				refresh_delivs: false,
                refresh_docs: false,

				current_modules: [],
				mktg_modules: [],
				model: null,
				progress_active: true,
				showPhoneNumber: false,

				secondaryUserDialog: false,
				parentUserId: String,
				secondaryProject: Object,
				show_addedUsers: false,
				show_addUserFeedback: false,
				added_user_feedback: '',

				thisUser: {
					user_id: null,
                    newuser_firstname: '',
                    newuser_lastname: '', 
                    newuser_email: '',
                    user_permissions: ['r','w'],
                    never_expires: true,
                    expiration_date: ''
                },
				resetCreateNewUser: false,

				admin_header: [
                    {   text: 'Full Name', value: 'first_name', align: 'start', width:'', sortable: true },
                    {   text: 'Phone', value: 'phone', align: 'left', width:'', sortable: true },
                    {   text: 'Email', value: 'user_email', align: 'left', width:'', sortable: true },
                ],
			}
		},
		
		mounted() {
			// this.getModules()
			// console.log(this.projects)
		},

		methods: {
			formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            },

			closeSecondary: async function () {
				this.parentUserId = ''
				this.resetCreateNewUser = true
                this.secondaryUserDialog = false
            },

			projectView: async function (view) {
				this.project_detail_view = view
			},

			showProject: async function ( prj ) {
				// console.log(prj)
				prj.show = !prj.show
				this.show_this = prj.show ? prj.project_id : ''
				this.project_detail_view = 'overview'
			},

			addSecondaryUser: async function ( prj ) {
				this.showProject( prj )
				this.secondaryUserDialog = true
				this.parentUserId = prj.user_id
				this.secondaryProject = prj
			},

			addUserFeedback: async function ( rs ) {
				this.secondaryUserDialog = false
				this.show_addUserFeedback = true
				this.show_addedUsers = rs.outcome
				this.added_user_feedback = rs.message

				setTimeout(() => {
					this.show_addUserFeedback = false
				}, 8000)
			},
			
			refreshUsers: async function ( parentUserId, projectId, message_override='' ) {
				try {
					// this.secondaryUserDialog = false
					const project_users = await axios.get(`${appUrls.api}/api/project_users/${parentUserId}/${projectId}/${this.authUser.is_secondary}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})
                
					// console.log(res.data)
					const this_project = this.projects.indexOf(this.projects.find( p => p.project_id == projectId))
					this.projects[this_project].users = project_users.data.users
					this.projects[this_project].admins = project_users.data.admins
                    
					const feedback_msg = message_override != '' ? message_override : project_users.data.message
					this.addUserFeedback({ outcome: project_users.data.outcome, message: feedback_msg });
                
				} catch ( error ) {
                    console.log(error);
                    this.addUserFeedback({ outcome: false, message: error });
                }
            },

			pullProjectDocs: async function ( project_details ) {
                try {
                    this.refresh_docs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        // console.log(pulled_files.data.files)
                        project_details.docs = pulled_files.data.files;
                        this.refresh_docs = false
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

			pullProjectDelivs: async function ( project_details ) {
                try {
                    this.refresh_delivs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        // console.log(pulled_files.data.files)
                        project_details.dlvs = pulled_files.data.files;
                        this.refresh_delivs = false
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            confirmedDeliverable: async function ( document_details ) {
                try {
                    const confirm_doc = await axios.post(`${appUrls.api}/api/confirm_deliverable/${document_details.file_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( confirm_doc.data.outcome ) {
                        this.refresh_delivs = true
                    }
                
                } catch ( error ) {
                    console.log(error);
                }
            }
		}
  }
</script>

<style scoped>
	.bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
	.project_title {
		font-size: 1.12rem !important;
	}
	.project_subtitle {
		font-size: 1rem !important;
	}
	.button_link {
		text-decoration-line: none;
		/* color: #5F6062; */
		/* font-size: 1.15rem!important; */
		/* font-size: 18px; */
	}
	.click_indicator {
		width:50px; 
		height:3px; 
		border-top:1px dotted rgba(0,0,0,.3);
		border-bottom:1px dotted rgba(0,0,0,.3);
	}
</style>


// WEBPACK FOOTER //
// src/components/DashProjects_good-old.vue